import React from 'react';
import ArrowIcon from "@/components/icons/ArrowIcon";
import CorrectIcon from "@/components/icons/CorrectIcon";
import WrongIcon from "@/components/icons/WrongIcon";

const QuestionChoice = ({color, background, value, onSelect, enabled=true, selected=false, isCorrect=false, isWrong=false, answerCount=0, percentFilled=0}) => {
	const dimness = enabled ? 'cursor-pointer' : 'pointer-events-none';
	const hasAnswerCount = answerCount !== 0;
	return <button
		className={`${background} rounded-lg px-4 ${hasAnswerCount && "!pr-0"} py-3 md:py-4 w-full ${dimness} flex items-center relative m-0.5 xs:m-0 text-base`}
		disabled={!enabled}
		onClick={onSelect}
		data-testid={`button-questionChoice`}>
		<div style={{width: `${percentFilled}%`}} className={`transition-all duration-500 absolute top-0 left-0 h-full bg-black bg-opacity-20 rounded-lg`} />
		<span className={`z-0 px-1`}>
			<ArrowIcon width={24} color={color} strokeColor={"white"} />
		</span>
		<span className={'w-full text-left z-0 font-gBold px-6 md:text-[28px] md:leading-[32px] text-[20px] leading-[24px]'}>{value}</span>
		<span className={'text-right z-0 font-gBold md:text-[28px] md:leading-[32px] text-[20px] leading-[24px]'}>{hasAnswerCount && answerCount}</span>
		<span className={`px-1`}>
			{isCorrect && !hasAnswerCount ? (
				<CorrectIcon width={20} />
			) : isWrong && !hasAnswerCount ? (
				<WrongIcon width={20} />
			) : (
				<div style={{ width: 20, height: 20 }}></div>
			)}
		</span>
	</button>
}

export default QuestionChoice;
